import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()((theme) => ({
    root: {
        paddingTop: theme.spacing(10),
        paddingBottom: theme.spacing(10),
    },
}))
